






import EditSchedule from "../../ServiceAndUpdates/ScheduleConfiguration/EditSchedule.vue";
import { ScheduleTypeEnum } from "@/model/data/scheduleSettings/ScheduleTypeEnum";
export default {
    components: { EditSchedule },
    props: {
        showDialog: Boolean,
        selectedInstallations: Array,
        initialSchedule: {
            type: Number as () => ScheduleTypeEnum,
        },
    },
    computed: {
        showEditScheduleDialog: {
            get() {
                return this.showDialog;
            },
            set(newValue: boolean) {
                console.log("set: ", newValue);
                this.$emit("update:showDialog", newValue);
            },
        },
    },
    data() {
        return {
            ScheduleTypeEnum,
        };
    },
    methods: {
        onClose(value) {
            this.$emit("close", value);
        },
    },
};
